// PublicPolicy.js
import React from "react";
import { Link, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";

export default function PublicPolicy() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col text-gray-900"
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        background: "linear-gradient(to bottom, #a0d8ff, #e6f3ff)",
      }}
    >
      {/* Navbar */}
      <nav className="w-full flex justify-center mt-6">
        <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-3 bg-white shadow-md rounded-full w-full max-w-screen-xl">
          <div
            className="font-bold text-lg md:text-xl px-4 py-2 rounded-full cursor-pointer"
            onClick={() => navigate("/")}
          >
            CollegeNavi
          </div>

          <Link
            to="/"
            className="px-4 py-2 rounded-full font-medium text-gray-900 hover:bg-gray-200 transition"
          >
            Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-6 md:px-12 mt-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white max-w-2xl w-full p-8 rounded-2xl shadow-lg border border-gray-200"
        >
          <h1 className="text-3xl font-extrabold mb-4 text-teal-800">
            Public Policy
          </h1>

          <p className="text-gray-700 mb-3">
            CollegeNavi is a platform for discovering college programs, competitions, and extracurricular opportunities. All content on the site is publicly available and accessible without registration.
          </p>

          <p className="text-gray-700 mb-3">
            Visitors can browse our admissions toolkit, view general program descriptions, and read informational content without providing any personal information.
          </p>

          <p className="text-gray-700 mb-3">
            We do not track or sell data from non-registered users. We may use cookies or analytics tools to improve site functionality, but no personal identification is collected.
          </p>

          <p className="text-gray-700 mb-3">
            Any links to external resources (such as program websites) may collect data independently. CollegeNavi is not responsible for the privacy practices of these external sites.
          </p>

          <p className="text-gray-700 mb-3">
            For registered users, see our <Link to="/privacy" className="text-teal-700 font-medium hover:underline">Privacy Policy</Link> for information about data usage and account management.
          </p>

          <p className="text-gray-700 mt-4">
            Contact us:{" "}
            <a
              href="mailto:collegecuriouspodcast@gmail.com"
              className="text-teal-700 font-medium hover:underline"
            >
              collegecuriouspodcast@gmail.com
            </a>
          </p>
        </motion.div>
      </main>
    </div>
  );
}
